module.exports = __webpack_public_path__ + "static/media/Ruskin_Logo.4d3370b0.png";